import { useEffect, useState } from "react";
import { Col, Form, Select } from "antd";
import { GET_BUYER_ENDPOINT } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";

const BookingQtyFilterFields = () => {
  const [buyerList, setBuyerList] = useState([]);
  const [buyerLoading, setBuyerLoading] = useState(false);
  const { Option } = Select;

  useEffect(() => {
    getBuyerList({ per_page: 10 });
  }, []);

  const getBuyerList = async (filterValues) => {
    setBuyerLoading(true);
    const bodyData = { per_page: 10, ...filterValues };
    const response = await getData(GET_BUYER_ENDPOINT, false, bodyData);
    if (response?.data?.code === 200) {
      setBuyerList(response?.data?.data?.data || []);
    }
    setBuyerLoading(false);
  };

  return (
    <Col span={4}>
      <Form.Item label="Buyer" name="buyer_id">
        <Select
          showSearch
          placeholder="Select Buyer"
          allowClear
          filterOption={false}
          loading={buyerLoading}
          onSearch={(value) => getBuyerList({ name: value })}
          onClear={() => getBuyerList({ per_page: 10 })}
          optionFilterProp="children"
          size="small"
        >
          {isArrayAndHasValue(buyerList) &&
            buyerList.map((item) => (
              <Option value={item.id} key={item.id}>
                {item.name}
              </Option>
            ))}
        </Select>
      </Form.Item>
    </Col>
  );
};

export default BookingQtyFilterFields;
